import React from 'react';
import PropTypes from 'prop-types';
import { Glyphicon } from 'react-bootstrap';

import withId from '../../decorators/withId';

export const Icon = ({ glyph }) => <Glyphicon glyph={glyph} />;

// TODO: glyph must be required
Icon.propTypes = {
  glyph: PropTypes.string,
};

Icon.defaultProps = {
  glyph: 'star',
};

export default withId('Icon')(Icon);
